module.exports = __webpack_public_path__ + "static/media/logo.95f72c8b.png";